var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElectricCarChargers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "electricCarChargers_svg__a",
    points: ".82 .564 34.255 .564 34.255 30.902 .82 30.902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "electricCarChargers_svg__c",
    points: ".947 .917 48.346 .917 48.346 166.746 .947 166.746"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.636 125.298C12.534 114.08.001 95.364.001 74.21c0-34.24 32.855-62.096 73.238-62.096 2.484 0 4.5 2.012 4.5 4.5 0 2.484-2.016 4.5-4.5 4.5C37.819 21.114 9 44.933 9 74.21c0 18.018 10.908 33.966 27.554 43.573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M143.343 136.913a8.586 8.586 0 01-8.586-8.59 8.587 8.587 0 018.586-8.586 8.587 8.587 0 018.586 8.586 8.586 8.586 0 01-8.586 8.59m-99.936 0a8.59 8.59 0 118.586-8.59 8.586 8.586 0 01-8.586 8.59m105.421-27.675H37.922c-9.468 0-17.145 7.677-17.145 17.15v22.252c0 9.468 7.676 17.15 17.145 17.15h110.906c9.469 0 17.145-7.682 17.145-17.15v-22.252c0-9.473-7.677-17.15-17.145-17.15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.836,
    x2: 40.836,
    y1: 156.787,
    y2: 180.187,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.912,
    x2: 145.912,
    y1: 156.787,
    y2: 180.187,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.903,
    x2: 115.428,
    y1: 12.337,
    y2: 12.112,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 4.5,
    points: "99.903 21.787 109.907 21.643 115.428 21.562"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.5 .937)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "electricCarChargers_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#electricCarChargers_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.576.563l9.679.184v30.155h-9.68l-.364-.234c-7.51-4.766-14.427-6.386-23.166-8.02l-.225-.044.594-13.383c0-.059.018-.068.018-.068 8.865-1.651 15.395-3.627 22.99-8.496l.154-.094z",
    mask: "url(#electricCarChargers_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M134.972 108.338H51.78c-1.917 0-3.2-2.556-2.425-4.829l8.78-25.82c.422-1.247 1.372-2.053 2.425-2.053h65.632c1.049 0 1.998.806 2.421 2.052l8.784 25.821c.77 2.273-.513 4.829-2.425 4.829m13.765-.19L137.694 70.25c-.53-1.832-1.728-3.01-3.05-3.01h-82.54c-1.318 0-2.515 1.178-3.05 3.01l-11.04 37.899c-.976 3.339.64 7.087 3.047 7.087h104.625c2.412 0 4.023-3.748 3.051-7.087"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183 21.437)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "electricCarChargers_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#electricCarChargers_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.668 166.746h-24.04c-6.452 0-11.681-5.228-11.681-11.681V12.599C.947 6.146 6.176.917 12.629.917h24.039c6.453 0 11.682 5.229 11.682 11.682v142.466c0 6.453-5.23 11.681-11.682 11.681",
    mask: "url(#electricCarChargers_svg__d)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCarChargers);
export default __webpack_public_path__ + "static/media/electricCarChargers.62d2e96a.svg";
export { ForwardRef as ReactComponent };